export enum CurriculumQueryKeys {
    PROGRAMMES = 'programmes',
    PROGRAMME = 'programme',
    LO = 'lo',
    LOS = 'los',
    YEARS = 'years',
    SLIDES = 'slides',
    PROGRAMME_RECOMMENDATIONS = 'programme_recommendations',
}
